export const trackPageView = (url: string) =>
  window && window.ga && window.ga("send", "pageview", { page: url });
